(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('p2ReportDef', {
        templateUrl: 'views/components/views/p2ReportDef/p2ReportDef.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'translateService', 'p2ReportDefService', 'p2ExportProcService', 'dbReportService', 'logisticService', 'docarcService', 'ttGridFactory', function ($stateParams, stateService, translateService, p2ReportDefService, p2ExportProcService, dbReportService, logisticService, docarcService, ttGridFactory) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let p2ReportDefKeyno = $stateParams.p2_reportdef_keyno;

            let translations = {
                papersize_standard: '',
                papersize_custom: ''
            };

            vm.model = {
                p2ReportDefKeyno: p2ReportDefKeyno,
                gridPrintersReady: false,
                webpageGridReady: false,
                usergroupGridReady: false,
                translations: {
                    change_default_printer: ''
                },
                tabs: {
                    selected: 'DETAILS',
                    buttons: [
                        { id: 'DETAILS', label: 'gb_p2reportdef_details', color: 'primary', onClick: () => vm.model.selected = 'DETAILS' },
                        { id: 'PRINTERS', label: 'gb_p2reportdef_printer', color: 'primary', onClick: () => vm.model.selected = 'PRINTERS' },
                        { id: 'WEBPAGES', label: 'gb_p2reportdef_webpages', color: 'primary', onClick: () => vm.model.selected = 'WEBPAGES' },
                        { id: 'USERGROUPS', label: 'gb_p2reportdef_usergroups', color: 'primary', onClick: () => vm.model.selected = 'USERGROUPS' }
                    ]
                },
                htmlReportsButtons: [
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('htmlreport', { htmlreport_keyno: vm.model.edit.htmlreport_keyno }) }
                ],
                docCategoryButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.doccategory_keyno = '0' },
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('doccategories') }
                ],
                edit: {},
                selectListWebPages: [],
                selectListEdiTypes: [],
                selectListPrinters: [],
                selectListReportTypes: [],
                selectListHtmlReports: [],
                selectListDocumentCategories: [],
                selectListPaperSizes: [
                    {
                        id: 'standard',
                        name: 'Standard'
                    },
                    {
                        id: 'custom',
                        name: 'Custom'
                    }
                ],
                lockedSave: false
            };

            vm.gridPrinters = new ttGridFactory({
                rememberId: 'w_p2reportdef_grid',
                kendo: {
                    height: '100%',
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            }).setLoadDataFunction({
                method: 2536,
                parameters: { p2_reportdef_keyno: p2ReportDefKeyno }
            }).setOptionFunc((data) => optionFuncPrinters(data.data));

            vm.webpageGrid = new ttGridFactory({
                rememberId: 'w_p2reportdef.webpagegrid',
                kendo: {
                    height: '100%',
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            }).setLoadDataFunction({
                method: 3410,
                parameters: { p2_reportdef_keyno: p2ReportDefKeyno }
            }).setAddRowFunction({
                method: null,
                parameters: { p2_reportdef_keyno: p2ReportDefKeyno },
                pre: null,
                post: null,
                autoSave: true,
                confirm: null
            }).setSaveDataFunction({
                method: null,
                parameters: { p2_reportdef_keyno: p2ReportDefKeyno },
                autoSave: true,
                confirm: null
            }).setRemoveRowFunction({
                method: null,
                parameters: {},
                autoSave: true,
                confirm: null,
                post: null
            }).setSpecialFunc({
                buttons: [
                    {
                        name: 'customDelete',
                        text: '',
                        icon: 'far-trash-alt',
                        type: 'danger',
                        func: async function (data) {
                            await vm.webpageGrid.gridfunc.removeRow(data);
                            vm.webpageGrid.gridfunc.saveChanges(false);
                        }
                    }
                ]
            });

            vm.usergroupGrid = new ttGridFactory({
                rememberId: 'w_p2reportdef.usergroupGrid',
                kendo: {
                    height: '100%',
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            }).setLoadDataFunction({
                method: 3481,
                parameters: { p2_reportdef_keyno: p2ReportDefKeyno }
            });

            // #endregion VARIABLES & DEFINITIONS

            // #region GRID OPTION FUNCTIONS

            function optionFuncPrinters(data) {
                if (data.func && data.func === 'OnCellClose') {
                    //console.log('optionfunc - OnCellClose');
                    //console.dir(data);

                    // Save the default printer to db.
                    dbReportService.setUserReportPrinter(vm.model.edit['p2_reportdef_keyno'], data['rdata']['default_printer_keyno'], data['rdata']['portal_user_keyno']);
                    vm.gridPrinters.gridfunc.rebind();
                }
            }

            // #endregion GRID OPTION FUNCTIONS

            // #region TRANSLATION BATCH FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION BATCH FUNCTION

            // #region TRANSLATION ON FUNCTION

            let deregTranslations = translateService.on(translations, 'changed', (result) => {
                deregTranslations();

                translations = result;

                vm.model.selectListPaperSizes.forEach((value) => {
                    //value.name = result['papersize_' + value.id];
                    value.name = 'papersize_' + value.id;
                });
            });

            // #endregion TRANSLATION ON FUNCTION

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function load() {
                const info = (await p2ReportDefService.getEdit({ p2_reportdef_keyno: p2ReportDefKeyno }))[0];

                if (info.paper_size_id === undefined) {
                    info.paper_size_id = 'standard';
                }

                if (info.width === undefined) {
                    info.width = 0;
                }

                if (info.height === undefined) {
                    info.height = 0;
                }

                vm.model.edit = info;

                vm.model.selectListReportTypes = await p2ReportDefService.listReportTypes();
                vm.model.selectListDocumentCategories = await docarcService.listDocumentCategories();
                vm.model.selectListHtmlReports = await p2ReportDefService.listHtmlReports();
                vm.model.selectListWebPages = await p2ReportDefService.listWebPages();
                vm.model.selectListEdiTypes = await p2ExportProcService.listEdiTypes();

                const selectListPrinters = await logisticService.listPrinters();

                vm.model.selectListPrinters = [{
                    item_id: '0',
                    item_name: 'Standard'
                }];

                selectListPrinters.forEach(printer => vm.model.selectListPrinters.push(printer));

                vm.model.gridPrintersReady = true;
                vm.model.webpageGridReady = true;
                vm.model.usergroupGridReady = true;
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region SAVE BUTTON FUNCTION

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                p2ReportDefService.saveObj(vm.model.edit).then(function () {
                    vm.model.lockedSave = false;
                    stateService.back();
                }, function () {
                    vm.model.lockedSave = false;
                });
            };

            // #endregion SAVE BUTTON FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                load();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
